'use client';

import { usePathname } from 'next/navigation';

interface IUseMatchPath {
  match: boolean;
  isExternal: boolean;
}

const useMatchPath = (path: string | undefined, mode: 'default' | 'full' = 'default'): IUseMatchPath => {
  const pathname = usePathname();
  let match = false;

  const matchPath = (pattern: string, pathname: string, end: boolean): boolean => {
    const pathParts = pattern.split('/').filter(Boolean);
    const pathnameParts = pathname.split('/').filter(Boolean);

    if (pathParts.length !== pathnameParts.length && end) return false;

    return pathParts.every((part, idx) => {
      return part.startsWith('[') || part.startsWith(':') || part === pathnameParts[idx];
    });
  };

  if (typeof path === 'string') {
    if (mode === 'default' && matchPath(path, pathname, true)) {
      match = true;
    } else if (mode === 'full' && matchPath(path, pathname, false)) {
      match = true;
    }
  }

  return {
    match,
    isExternal: typeof path === 'string' && (path.startsWith('http') || path.startsWith('//')),
  };
};
export { useMatchPath };
